import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { RootState } from '@src/store/store'
import { useSelector } from 'react-redux'

import { useDialog } from '@src/hooks/common/useDialog'
import LoginDialog from '../login-dlalog'

type Props = {
  children: React.ReactNode
  path: string
}

export default function AuthWrapper({ children, path }: Props) {
  const accountInfo = useSelector((state: RootState) => state.account.accountInfo)
  const isLoggedIn = accountInfo?.token
  const showLogin = useDialog()
  const location = useLocation()

  useEffect(() => {
    if (!isLoggedIn) {
      showLogin.open()
    }
  }, [location.pathname])

  if (!isLoggedIn) {
    return <LoginDialog showLogin={showLogin} targetPath={path} />
  }

  return <>{children}</>
}
